import React from "react";
import { CheckCircle2, Award, Users, Heart } from "lucide-react";
import { Button } from "./ui/button";

const points = [
  "Fix website and Google listing issues fast",
  "Climb to the top of map &amp; search listings",
  "Leverage your Google reviews to 3X customer retention",
  "Stand out from competitors with AI-built content to increase traffic &amp; revenue",
];

const features = [
  { icon: Award, title: "20+ Years Experience", text: "Business & technical mastery you can trust." },
  { icon: Users, title: "Veteran Owned", text: "Proud USMC veteran at the helm." },
  { icon: Heart, title: "Charity Driven", text: "A portion of every dollar goes to charities." },
];

export default function About() {
  return (
    <section id="about" className="pt-20 pb-10 sm:py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
        <div className="relative order-2 lg:order-1">
          <div className="rounded-2xl overflow-hidden border border-slate-200 shadow-xl bg-white">
            <img
              src="https://customer-assets.emergentagent.com/job_savvy-support/artifacts/7j8eiysh_vetTechLogog.jpg"
              alt="411TechSavvy - Veteran Owned Technology Business"
              className="block w-full h-auto"
            />
          </div>
          <div className="mt-3 bg-white/95 backdrop-blur rounded-xl border border-slate-200 shadow-xl px-3 py-2 sm:px-3.5 sm:py-2.5 max-w-full sm:max-w-md mx-auto sm:mx-0">
            <div className="text-[10px] sm:text-xs uppercase tracking-widest text-cyan-700 font-bold">Meet</div>
            <div className="text-base sm:text-lg font-bold text-slate-900 leading-tight">Eddie Kirk AzTn</div>
            <div className="text-xs sm:text-sm text-slate-600 leading-snug">Web Media Tech Analyst &amp; USMC Veteran</div>
          </div>
        </div>

        <div className="order-1 lg:order-2">
          <div className="text-xs uppercase tracking-widest text-cyan-700 font-bold">About 411TechSavvy</div>
          <h2 className="mt-3 text-3xl md:text-4xl font-extrabold text-slate-900 leading-tight">
            Helping local businesses unlock today&rsquo;s newest tech.
          </h2>
          <p className="mt-5 text-slate-600 leading-relaxed">
            Today&rsquo;s technology offers a tremendous opportunity to elevate your business visibility through
            Internet Marketing &amp; Advertising on Google, Facebook, YouTube and more. Leveraging it takes
            expertise and time. That&rsquo;s where Eddie comes in.
          </p>
          <p className="mt-3 text-slate-900 font-bold italic text-lg leading-snug">
            Your Trusted Friendly Neighborhood<br />
            <span className="text-cyan-700">IT &amp; Tech Savvy Guy.</span>
          </p>

          <ul className="mt-6 space-y-3">
            {points.map((p) => (
              <li key={p} className="flex items-start gap-3 text-slate-700">
                <CheckCircle2 className="h-5 w-5 text-cyan-600 mt-0.5 flex-shrink-0" />
                <span dangerouslySetInnerHTML={{ __html: p }} />
              </li>
            ))}
          </ul>

          <div className="mt-7 grid sm:grid-cols-3 gap-3">
            {features.map((f) => {
              const Ic = f.icon;
              return (
                <div
                  key={f.title}
                  className="rounded-xl border border-slate-200 bg-slate-50 p-4 card-hover"
                >
                  <Ic className="h-5 w-5 text-cyan-700" />
                  <div className="mt-2 font-bold text-slate-900 text-sm">{f.title}</div>
                  <div className="text-xs text-slate-500 mt-1">{f.text}</div>
                </div>
              );
            })}
          </div>

          <div className="mt-7">
            <Button asChild className="bg-cyan-600 hover:bg-cyan-700 text-white h-11 px-6 font-semibold">
              <a href="#services">Explore Services</a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
